module.exports = __webpack_public_path__ + "img/icon-value-removed.1efc9703.svg";